module.exports = __webpack_public_path__ + "img/vessel_visitation_7_63021.801cd01f.jpg";